<template>
    <media-library-item 
            class="media-library-file" 
            v-bind:name-editor-placeholder="resource('MediaLibrary_RenameFile_Placeholder')"
            v-bind:name="name" 
            v-on:item-clicked="$emit('file-selected')"
            v-on:item-double-clicked="$emit('file-picked')"
            v-on:item-renamed="rename($event)"
    >
        <file-icon v-bind:name="this.name" v-bind:size="'3x'"></file-icon>
    </media-library-item>
</template>

<script>
    import mediaApi from '../../../Api/media-library';
    import getResource from '../../../Util/resources';
    
    import {error as errorNotification } from "../Util/notifications";

    import MediaLibraryItem from './BaseMediaLibraryItem.vue';
    import FileIcon from '../../../Components/Util/FileIcon.vue';


    export default {
        name: 'media-library-file',
        components:{
            MediaLibraryItem,
            FileIcon
        },
        methods: {
            rename(newName) {
                const vm = this;

                mediaApi.renameFile({
                    newName: newName,
                    id: vm.id
                }).then(((res) => {
                    vm.$emit('file-renamed', res.name)
                }), errorNotification);
            },
            resource(name){
                return getResource(name);
            }
        },
        props: {
            name: {
                type: String,
                required: true
            },
            id: {
                type: String,
                required: true
            }
        }
    };
</script>

<style scoped src="../Style/media-library-file.scss" lang="scss">
    
</style>
